module.exports = __webpack_public_path__ + "img/wash-day-diaries.a5e10185.png";